var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AudioTextHighlight,{attrs:{"paragraph-list":_setup.contentList,"url-link":_setup.audioSrc,"title":_setup.taskTitle,"type":"asr","loading":_setup.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }